export default __webpack_public_path__ + "static/media/ip.26604f18.png";